import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EducationProgramDTO } from '../apis/education/education.dto';
import { RehabilitationProgramDTO } from '../apis/rehabilitation/rehabilitation.dto';
import { ServiceDTO } from '../apis/service/service.dto';
import { BookingStorageEnum } from '../enums/booking.enum';
import {
  IBookingChoosen,
  IBookingStorage,
} from '../interfaces/booking.interface';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public chosenPrograms$: BehaviorSubject<IBookingChoosen> =
    new BehaviorSubject<IBookingChoosen>({
      rehabilitation: null,
      education: null,
      service: null,
    });

  public getChosenPrograms(): IBookingStorage {
    return JSON.parse(localStorage.getItem('chosenPrograms') || '{}');
  }

  public deleteChosenProgram(
    programType: BookingStorageEnum,
    program: RehabilitationProgramDTO | EducationProgramDTO | ServiceDTO
  ): void {
    const chosenPrograms = this.removeProgram(programType, program.id);
    this.savePrograms(programType, program.id);
    this.chosenPrograms$.next(chosenPrograms);
  }

  private removeProgram(
    programType: BookingStorageEnum,
    id: number
  ): IBookingChoosen {
    const chosenPrograms: IBookingChoosen = this.chosenPrograms$.value;
    let index;
    if (chosenPrograms) {
      index = chosenPrograms[programType]?.findIndex((item) => item.id === id);
      (index || index == 0) &&
        index >= 0 &&
        chosenPrograms[programType]?.splice(index, 1);
    }
    return chosenPrograms;
  }

  private savePrograms(programType: BookingStorageEnum, id: number): void {
    const chosenPrograms: IBookingStorage = this.getChosenPrograms();
    chosenPrograms[programType];
    let index;
    if (chosenPrograms) {
      index = chosenPrograms[programType]?.findIndex((item) => item === id);
      (index || index == 0) &&
        index >= 0 &&
        chosenPrograms[programType]?.splice(index, 1);
    }

    const saveData = JSON.stringify(chosenPrograms);
    localStorage.setItem('chosenPrograms', saveData);
  }

  public saveProgramsFromBooking(ids: IBookingStorage): void {
    const newObjectIds = this.processIds(ids);
    const existingPrograms = this.getChosenPrograms();
    const mergedObjectIds = this.mergeObjects(newObjectIds, existingPrograms);
    const saveData = JSON.stringify(mergedObjectIds);
    localStorage.setItem('chosenPrograms', saveData);
  }

  private processIds(ids: IBookingStorage): IBookingStorage {
    const result: IBookingStorage = {
      [BookingStorageEnum.rehabilitation]: [],
      [BookingStorageEnum.education]: [],
      [BookingStorageEnum.service]: [],
    };

    Object.keys(ids).forEach((key) => {
      const enumKey = key as keyof typeof BookingStorageEnum;
      const value = ids[BookingStorageEnum[enumKey]];
      result[BookingStorageEnum[enumKey]] = value ? value : [];
    });

    return result;
  }

  private mergeObjects(
    obj1: IBookingStorage,
    obj2: IBookingStorage
  ): IBookingStorage {
    const result: IBookingStorage = {
      [BookingStorageEnum.rehabilitation]: [],
      [BookingStorageEnum.education]: [],
      [BookingStorageEnum.service]: [],
    };

    for (const key of Object.keys(obj1) as Array<keyof IBookingStorage>) {
      const value = obj1[key];
      result[key] = [...new Set([...(result[key] || []), ...(value || [])])];
    }

    for (const key of Object.keys(obj2) as Array<keyof IBookingStorage>) {
      const value = obj2[key];
      result[key] = [...new Set([...(result[key] || []), ...(value || [])])];
    }

    return result;
  }
}
